import { render, staticRenderFns } from "./addFollowUp.vue?vue&type=template&id=13574722&scoped=true&"
import script from "./addFollowUp.vue?vue&type=script&lang=js&"
export * from "./addFollowUp.vue?vue&type=script&lang=js&"
import style0 from "./addFollowUp.vue?vue&type=style&index=0&id=13574722&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13574722",
  null
  
)

export default component.exports